import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline} from "gsap";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {BookOfShadows} from "../../BookOfShadows";

export class BookOfShadowsNearWin implements GameRoundPresentation {
    private readonly _reelId: number;
    private readonly _duration: number;

    /**
     * @constructs
     * @param reelId
     * @param duration
     */
    constructor(reelId: number, duration: number) {
        this._reelId = reelId;
        this._duration = duration;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: SpinParsedGameData): Timeline | null {
        if (data.nearWinReels[this._reelId]) {
            return BookOfShadows.timelineReelsController.startNearWin(this._reelId, this._duration);
        }

        return null;
    }
}